/* pp-guide-cid.js (Oct 23 2026)
   Adds the See Your Pearls guide conversation id to every photo request,
   from any page, so staff can look up the chat that led to it in the Studio.

   The guide keeps its session in sessionStorage['ppgd_session'] (JSON, field
   cid). When a request is posted to the photo request Worker, this reads cid
   and adds it to the request as guide_cid. It is never shown to customers.

   It can never block or slow a request: if there is no id, if it cannot be
   read or parsed, or if anything here fails, the request goes out exactly as
   it was. Requests from the product page (pp-pdp.js) and the drawer
   (pp-sbs.js) both go through window.fetch, so both are covered here without
   touching either file. */
(function () {
  if (window.__ppGuideCid || !window.fetch) return;
  window.__ppGuideCid = true;
  var ENDPOINT = 'photo-requests.jeremypshepherd.workers.dev/request';

  function cid() {
    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem('ppgd_session');
      var s = raw ? JSON.parse(raw) : null;
      var c = s && (typeof s.cid === 'string' || typeof s.cid === 'number') ? String(s.cid).trim() : '';
      return /^[A-Za-z0-9_.:-]{3,100}$/.test(c) ? c : '';
    } catch (e) { return ''; }
  }

  function wrap(fn) {
    var w = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf(ENDPOINT) !== -1 && url.indexOf(ENDPOINT + '/') === -1 && init && typeof init.body === 'string' && (init.method || '').toUpperCase() === 'POST') {
          var id = cid();
          if (id) {
            var body = JSON.parse(init.body);
            if (body && typeof body === 'object' && !body.guide_cid) {
              body.guide_cid = id;
              init = Object.assign({}, init, { body: JSON.stringify(body) });
            }
          }
        }
      } catch (e) { /* leave the request as it was */ }
      return fn.apply(window, [input, init].slice(0, arguments.length || 1));
    };
    w.__ppGuide = true;
    return w;
  }

  // Other scripts on the page (analytics, apps) also wrap fetch, some after
  // this file runs. Keeping fetch as a property that re-wraps whatever is
  // assigned keeps this layer outermost, so no request slips past it.
  var current = window.fetch, wrapped = wrap(current);
  try {
    Object.defineProperty(window, 'fetch', {
      configurable: true, enumerable: true,
      get: function () { return wrapped; },
      set: function (v) { if (typeof v === 'function' && v !== wrapped && !v.__ppGuide) { current = v; wrapped = wrap(v); } }
    });
  } catch (e) { window.fetch = wrapped; }
})();
